var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 178,
    viewBox: "0 0 150 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 167C116.421 167 150 133.421 150 92C150 50.5786 116.421 17 75 17C33.5786 17 0 50.5786 0 92C0 133.421 33.5786 167 75 167Z",
    fill: "#F7F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1745_15179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 60H32C29.2386 60 27 62.2386 27 65V170C27 172.761 29.2386 175 32 175H118C120.761 175 123 172.761 123 170V65C123 62.2386 120.761 60 118 60Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 75H39C37.3431 75 36 76.3431 36 78C36 79.6569 37.3431 81 39 81H65C66.6569 81 68 79.6569 68 78C68 76.3431 66.6569 75 65 75Z",
    fill: "#D1D1D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 88H39C37.3431 88 36 89.3431 36 91C36 92.6569 37.3431 94 39 94H83C84.6569 94 86 92.6569 86 91C86 89.3431 84.6569 88 83 88Z",
    fill: "#F4F4F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65 102H39C37.3431 102 36 103.343 36 105C36 106.657 37.3431 108 39 108H65C66.6569 108 68 106.657 68 105C68 103.343 66.6569 102 65 102Z",
    fill: "#D1D1D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83 115H39C37.3431 115 36 116.343 36 118C36 119.657 37.3431 121 39 121H83C84.6569 121 86 119.657 86 118C86 116.343 84.6569 115 83 115Z",
    fill: "#F4F4F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 129H39C37.3431 129 36 130.343 36 132C36 133.657 37.3431 135 39 135H65C66.6569 135 68 133.657 68 132C68 130.343 66.6569 129 65 129Z",
    fill: "#D1D1D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83 142H39C37.3431 142 36 143.343 36 145C36 146.657 37.3431 148 39 148H83C84.6569 148 86 146.657 86 145C86 143.343 84.6569 142 83 142Z",
    fill: "#F4F4F5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1745_15179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 9H32C29.2386 9 27 11.2386 27 14V44C27 46.7614 29.2386 49 32 49H118C120.761 49 123 46.7614 123 44V14C123 11.2386 120.761 9 118 9Z",
    fill: "#F0F0F0"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65 20H39C37.3431 20 36 21.3431 36 23C36 24.6569 37.3431 26 39 26H65C66.6569 26 68 24.6569 68 23C68 21.3431 66.6569 20 65 20Z",
    fill: "#D1D1D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83 33H39C37.3431 33 36 34.3431 36 36C36 37.6569 37.3431 39 39 39H83C84.6569 39 86 37.6569 86 36C86 34.3431 84.6569 33 83 33Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1745_15179",
    x: 21,
    y: 51,
    width: 108,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1745_15179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1745_15179",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1745_15179",
    x: 21,
    y: 0,
    width: 108,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1745_15179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1745_15179",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/Container.25c33e8c82a141b5bcd5a7216bd816fc.svg";
export { ForwardRef as ReactComponent };